import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaX } from "react-icons/fa6";
import { NavLink } from "react-router-dom";

export default function HeaderComponent() {
  const [openTab, setOpenTab] = useState(false);
  const [mobileDropdown, setMobileDropdown] = useState(false);

  return (
    <nav className="w-full bg-white shadow-md  z-50">
      <div className="container mx-auto px-4 lg:px-8 flex items-center justify-between h-20">
        
        {/* Logo */}
        <NavLink to="/" end>
          <img
            src="/TECH X AFRICA 1.png"
            alt="Logo"
            className="w-32 sm:w-36 object-contain"
          />
        </NavLink>

        {/* Desktop Menu */}
        <div className="hidden lg:flex items-center gap-10 text-[17px] font-medium">
          <NavLink 
            to="/#about"
            className="hover:text-[#F63A0A] transition-all"
          >
            About
          </NavLink>

          <NavLink 
            to="/who-attended"
            className="hover:text-[#F63A0A] transition-all"
          >
            Who Attended
          </NavLink>

          {/* Desktop Dropdown */}
          <div className="relative group">
            <button className="hover:text-[#F63A0A] transition-all">
              Get Involved
            </button>

            <div className="absolute top-full left-0 bg-white shadow-lg rounded-lg py-3 min-w-[210px]
                            opacity-0 invisible group-hover:opacity-100 group-hover:visible 
                            transition-all duration-300">
              <a
                href="https://bit.ly/txavolunteer2025"
                target="_blank"
                className="block px-5 py-2 hover:bg-gray-100 hover:text-[#F63A0A] transition"
              >
                Apply to Volunteer
              </a>
              <a
                href="/TXA 25 Official Proposal.pdf"
                download
                className="block px-5 py-2 hover:bg-gray-100 hover:text-[#F63A0A] transition"
              >
                Become a Sponsor
              </a>
              <a
                href="https://wa.me/+2348123051357"
                target="_blank"
                className="block px-5 py-2 hover:bg-gray-100 hover:text-[#F63A0A] transition"
              >
                Become a Partner
              </a>
            </div>
          </div>
        </div>

        {/* Mobile Toggle */}
        <div className="lg:hidden">
          {!openTab ? (
            <GiHamburgerMenu
              size={28}
              className="cursor-pointer text-black"
              onClick={() => setOpenTab(true)}
            />
          ) : (
            <FaX
              size={28}
              className="cursor-pointer text-black"
              onClick={() => setOpenTab(false)}
            />
          )}
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`overflow-hidden transition-[max-height] duration-500 bg-white lg:hidden shadow-inner ${
          openTab ? "max-h-[500px]" : "max-h-0"
        }`}
      >
        <div className="flex flex-col gap-1 px-5 py-5">

          <NavLink
            to="/#about"
            onClick={() => setOpenTab(false)}
            className="py-3 font-semibold rounded-lg hover:bg-gray-100 hover:text-[#F63A0A] transition-all"
          >
            About
          </NavLink>

          <NavLink
            to="/who-attended"
            onClick={() => setOpenTab(false)}
            className="py-3 font-semibold rounded-lg hover:bg-gray-100 hover:text-[#F63A0A] transition-all"
          >
            Who Attended
          </NavLink>

          {/* Mobile Dropdown */}
          <div>
            <button
              onClick={() => setMobileDropdown(!mobileDropdown)}
              className="w-full text-left py-3 font-semibold rounded-lg hover:bg-gray-100 hover:text-[#F63A0A] transition-all"
            >
              Get Involved
            </button>

            <div
              className={`flex flex-col transition-[max-height] duration-500 overflow-hidden ${
                mobileDropdown ? "max-h-64 mt-1" : "max-h-0"
              }`}
            >
              <a
                href="https://bit.ly/txavolunteer2025"
                target="_blank"
                className="py-3 pl-6 rounded-lg hover:bg-gray-100 hover:text-[#F63A0A]"
                onClick={() => {
                  setOpenTab(false);
                  setMobileDropdown(false);
                }}
              >
                Apply to Volunteer
              </a>

              <a
                href="/TXA 25 Official Proposal.pdf"
                download
                className="py-3 pl-6 rounded-lg hover:bg-gray-100 hover:text-[#F63A0A]"
                onClick={() => {
                  setOpenTab(false);
                  setMobileDropdown(false);
                }}
              >
                Become a Sponsor
              </a>

              <a
                href="https://wa.me/+2348123051357"
                target="_blank"
                className="py-3 pl-6 rounded-lg hover:bg-gray-100 hover:text-[#F63A0A]"
                onClick={() => {
                  setOpenTab(false);
                  setMobileDropdown(false);
                }}
              >
                Become a Partner
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
